import { render } from "./Attrition.vue?vue&type=template&id=02e611b7&scoped=true"
import script from "./Attrition.vue?vue&type=script&lang=js"
export * from "./Attrition.vue?vue&type=script&lang=js"

import "./Attrition.vue?vue&type=style&index=0&id=02e611b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e611b7"]])

export default __exports__